import type { AnalysisPageSearchQueryStates } from '../_hooks/search-query-states';

const SEARCH_HISTORY_STORAGE_KEY = 'analysis-search-history';

export const getAnalysisSearchHistory = (): AnalysisPageSearchQueryStates[] => {
  const storedHistory = sessionStorage.getItem(SEARCH_HISTORY_STORAGE_KEY);
  return storedHistory ? JSON.parse(storedHistory) : [];
};

export const setAnalysisSearchHistory = (
  history: AnalysisPageSearchQueryStates[],
) => {
  sessionStorage.setItem(SEARCH_HISTORY_STORAGE_KEY, JSON.stringify(history));
};

export const removeAnalysisSearchHistory = () => {
  sessionStorage.removeItem(SEARCH_HISTORY_STORAGE_KEY);
};
